import { render } from "./our-team.vue?vue&type=template&id=fd7ddb0a"
import script from "./our-team.vue?vue&type=script&lang=js"
export * from "./our-team.vue?vue&type=script&lang=js"
script.render = render

export default script